import { render, staticRenderFns } from "./shopDetail.vue?vue&type=template&id=5419f26b&scoped=true"
import script from "./shopDetail.vue?vue&type=script&lang=js"
export * from "./shopDetail.vue?vue&type=script&lang=js"
import style0 from "./shopDetail.vue?vue&type=style&index=0&id=5419f26b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5419f26b",
  null
  
)

export default component.exports